import React from "react";
import { Tag, ArrowRight, Snowflake, Cable, Zap, Plug } from "lucide-react";

// Highlights the 4 most-asked-about prices, shown right under the hero
// so visitors see real numbers within the first scroll — without having to
// hunt for the full price list buried later in the page.
const HIGHLIGHTS = [
  {
    icon: Cable,
    label: "12 Pin Trailer Plug Install",
    price: "From $495*",
    note: "Basic 12 pin · with relay · GST inc",
  },
  {
    icon: Zap,
    label: "REDARC Tow-Pro Elite Brake Controller",
    price: "From $805",
    note: "Supply + install · GST inc",
  },
  {
    icon: Plug,
    label: "Grey Anderson Plug Install",
    price: "From $495",
    note: "No relay $495 · with relay $550",
  },
  {
    icon: Snowflake,
    label: "A/C Service",
    price: "From $154",
    note: "Starting price · GST inc",
  },
];

const TWELVE_PIN_DISCLAIMER =
  "* Price shown is for a basic 12 pin plug install. Additional charges may apply if extra pins or circuits are required.";

export default function PricingSnapshot() {
  return (
    <section
      data-testid="pricing-snapshot"
      className="relative bg-[#0A0A0A] border-y border-cyan-pz/20 py-14 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-10 bg-cyan-pz" />
              <span className="bebas text-cyan-pz tracking-[0.3em] text-sm">
                UP-FRONT PRICING
              </span>
            </div>
            <h2 className="bebas text-white text-3xl md:text-5xl leading-[0.95] tracking-tight">
              KNOW THE PRICE <span className="text-cyan-pz">BEFORE</span> YOU CALL.
            </h2>
          </div>
          <a
            href="#pricing"
            data-testid="snapshot-full-prices-btn"
            className="inline-flex items-center justify-center gap-2 self-start md:self-auto bg-cyan-pz text-black px-6 py-3 bebas tracking-widest hover:bg-white transition-colors clip-perf"
          >
            <Tag className="w-4 h-4" />
            SEE FULL PRICE LIST
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {HIGHLIGHTS.map((h) => {
            const Icon = h.icon;
            return (
              <a
                key={h.label}
                href="#pricing"
                data-testid={`snapshot-${h.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group relative bg-black p-5 md:p-7 hover:bg-cyan-pz/5 transition-colors"
              >
                <Icon className="w-6 h-6 text-cyan-pz mb-3" />
                <p className="text-white/60 barlow text-xs md:text-sm leading-snug mb-2 min-h-[2.5rem]">
                  {h.label}
                </p>
                <p className="bebas text-cyan-pz text-3xl md:text-4xl tracking-wider glow-cyan-subtle group-hover:text-white transition-colors">
                  {h.price}
                </p>
                <p className="text-white/40 text-[11px] barlow mt-1">
                  {h.note}
                </p>
              </a>
            );
          })}
        </div>

        <p className="mt-5 text-white/50 barlow text-xs md:text-sm">
          Workshop rate $165/hr GST inc (1hr min) · Written quotes on bigger jobs · No hidden labour fees · Same-day bookings often available
        </p>
        <p data-testid="snapshot-12pin-disclaimer" className="mt-2 text-white/40 barlow text-xs">
          {TWELVE_PIN_DISCLAIMER}
        </p>
      </div>
    </section>
  );
}
